import { SignalStoreBuilder } from "src/app/_stores/SignalStoreBuilder";
import { BatteryData } from "src/app/_models/location/battery/BatteryData";
import { BatteryDataDto } from "src/app/_models/location/LocationDTO";

type BatteryDataMap = {
  id_battery: number;
  data: BatteryData[];
};

export const SignalBatteryDataStore = new SignalStoreBuilder<BatteryDataMap>(
  (entry) => entry.id_battery,
  (json) => {
    const id = json["id_battery"] as number;
    const data = (json["data"] as unknown[]).map((d) =>
      BatteryData.fromDto(BatteryDataDto.fromJson(d)),
    );
    return { id_battery: id, data };
  },
)
  .withMethod("loadAllLatest", (_store, http, { upsert }) => async () => {
    const response = await http.get("batteries/data", { hideLoader: true });
    if (!response) return;
    for (const item of response as any as {
      id_battery: number;
      data: unknown;
    }[]) {
      if (!item.data) continue;
      const incoming = BatteryData.fromDto(BatteryDataDto.fromJson(item.data));
      const existing = _store.entityMap()[item.id_battery]?.data ?? [];
      upsert({
        id_battery: item.id_battery,
        data: [incoming, ...existing.filter(d => d.created_at.getTime() !== incoming.created_at.getTime())],
      });
    }
  })
  .withMethod(
    "loadData",
    (_store, http, { upsert }) =>
      async (id_battery: number, limit: number = 120) => {
        const response = await http.get(
          `batteries/${id_battery}/data?limit=${limit}`,
          { hideLoader: true },
        );
        if (!response) return;
        const data = (response["data"] as unknown[]).map((d) =>
          BatteryData.fromDto(BatteryDataDto.fromJson(d)),
        );
        upsert({ id_battery, data });
      },
  )
  .withMethod(
    "loadLatest",
    (_store, http, { upsert }) =>
      async (id_battery: number) => {
        const response = await http.get(
          `batteries/${id_battery}/data?limit=1`,
          { hideLoader: true },
        );
        if (!response) return;
        const incoming = (response["data"] as unknown[]).map((d) =>
          BatteryData.fromDto(BatteryDataDto.fromJson(d)),
        );
        const existing = _store.entityMap()[id_battery]?.data ?? [];
        const merged = [
          ...incoming,
          ...existing.filter(e => !incoming.some(i => i.created_at.getTime() === e.created_at.getTime())),
        ];
        upsert({ id_battery, data: merged });
      },
  )
  .withAutoRefresh((store) => store.loadAllLatest())
  .providedInRoot()
  .build();
